"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDataExplorerFilters = mapDataExplorerFilters;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _filters = require("../util/filters");
const crossCompatibleFilters = ['i_device_id', 'i_device_label', 'i_device_name', 'i_device_site_id', 'i_device_site_name', 'i_device_subtype', 'i_device_type', 'i_input|output_interface_description', 'i_input|output_interface_group', 'i_input|output_snmp_alias', 'inet_src|dst_addr'];
const filterMappings = {
  i_device_name: 'device_name',
  'i_input|output_interface_description': 'name',
  'i_input|output_snmp_alias': 'description',
  'inet_src|dst_addr': 'device_ip'
};
const filterMeasurementConstraints = {
  'i_input|output_interface_description': model => model.measurement.startsWith('/interfaces/'),
  'i_input|output_snmp_alias': model => model.measurement.startsWith('/interfaces/')
};

/**
 * Finds a dimension in the measurement model that has a QueryColumn matching the filter's filterField.
 * This is used as a fallback to map filters that aren't in the allowedFilters list but can still be mapped to dimensions based on their QueryColumn,
 * which allows for more flexible filtering without needing to explicitly support every possible filter field.
 *
 * @param filter {FilterObj} - the filter to find a matching dimension for
 * @param measurementModel {MeasurementModel} - the measurement model to search for dimensions in
 * @returns {string | null} the name of the dimension with a QueryColumn matching the filter field, or null if no match is found
 */
const findDimWithMatchingQueryColumn = (filter, measurementModel) => {
  const {
    Dimensions = {}
  } = measurementModel.storage || {};
  if ((0, _isEmpty2.default)(Dimensions)) {
    return null;
  }
  return Object.entries(Dimensions).find(([_, dim]) => dim.QueryColumn === filter.filterField)?.[0] ?? null;
};

/**
 * Metric Explorer queries will break if we try to filter by unsupported dimensions.
 * This function ensure that we only include filters that can be mapped to dimensions in the measurement model,
 * either through explicit mappings for known filter fields or by matching filter fields to dimension QueryColumns.
 *
 * Maps Metrics Explorer dimensions to Data Explorer dimensions in filters,
 * and also allows for mapping based on matching QueryColumns as a fallback.
 * If an appropriate filter cannot be found or mapped, it is removed from the filters list.
 *
 * @param dataExplorerFilters
 * @param kmetricsMeasurementModel
 */
function mapDataExplorerFilters(dataExplorerFilters, kmetricsMeasurementModel) {
  const {
    Dimensions = {}
  } = kmetricsMeasurementModel.storage || {};
  return (0, _filters.mapFilters)(dataExplorerFilters, filter => {
    if (crossCompatibleFilters.includes(filter.filterField)) {
      const mapping = filterMappings[filter.filterField];
      const constraint = filterMeasurementConstraints[filter.filterField];
      if (constraint && !constraint(kmetricsMeasurementModel)) {
        // filter can't be used here
        return null;
      }
      if (!mapping) {
        // no transformation needed
        return filter;
      }
      if (Dimensions[mapping]) {
        return {
          ...filter,
          filterField: mapping
        };
      }
    }
    if (filter.filterField in Dimensions) {
      // filter is already mapped to a dimension and is therefore compatible, so we can use it as is
      return filter;
    }

    // try to find a dimension with a matching QueryColumn as a fallback mapping option
    const dimWithMatchingQueryColumn = findDimWithMatchingQueryColumn(filter, kmetricsMeasurementModel);
    if (dimWithMatchingQueryColumn) {
      // filter field matches a dimension query column, so we can map it
      return {
        ...filter,
        filterField: dimWithMatchingQueryColumn
      };
    }

    // filter can't be mapped
    return null;
  });
}